import React from "react";
import cx from "classnames";

import { TabBar } from "src/components/tabbar";

import styles from "./tabs.module.scss";

export type StoryboardSettingsTab =
  | "siteSettings"
  | "leadsAndReports"
  | "rolesPermissions"
  | "contentManager"
  | "customFields"
  | "leadsAndReports"
  | "personalization"
  | "abmCampaign"

const buildTabOrder = (
  showResourceCenterTabs: boolean,
): { key: StoryboardSettingsTab; label: string }[] => {
  const tabs = [
    { key: "siteSettings", label: "Site Settings" },
    { key: "leadsAndReports", label: "Leads & Reports" },
    // { key: "rolesPermissions", label: "Roles & Permission" },
  ] as { key: StoryboardSettingsTab; label: string }[];

  return tabs;
};

interface TabsProps {
  active: StoryboardSettingsTab;
  onChange: (tab: StoryboardSettingsTab) => void;
  manageable?: boolean;
  showResourceCenterTabs?: boolean;
}

const Tabs: React.FC<TabsProps> = ({
  active,
  onChange,
  manageable = false,
  showResourceCenterTabs = false,
}) => {
  const tabOrder = buildTabOrder(showResourceCenterTabs).filter((t) =>
    t.key === "rolesPermissions" ? manageable : true
  );
  const activeIndex = tabOrder.findIndex((t) => t.key === active);

  return (
    <TabBar
      active={activeIndex >= 0 ? activeIndex : 0}
      gap={32}
      onSelectionChange={(idx) => onChange(tabOrder[idx].key)}
    >
      {tabOrder.map((tab, idx) => (
        <span
          key={tab.key}
          className={cx(styles.tabLabel, { [styles.active]: idx === activeIndex })}
        >
          {tab.label}
        </span>
      ))}
    </TabBar>
  );
};

export default Tabs;